/* eslint-disable @typescript-eslint/no-explicit-any */
// Google Analytics 4 tracking utilities

import { SubmitData } from "../types/form";

// Declare gtag for TypeScript
declare global {
  interface Window {
    gtag: (
      command: "config" | "event",
      targetId: string,
      params?: {
        page_title?: string;
        page_location?: string;
        event_category?: string;
        event_label?: string;
        value?: any;
        [key: string]: any;
      }
    ) => void;
  }
}

// Initialize Google Analytics
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

// Initialize GA4
export const initGA = (): void => {
  if (typeof window !== "undefined" && GA_TRACKING_ID) {
    window.gtag("config", GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (url: string, title: string): void => {
  if (typeof window !== "undefined" && GA_TRACKING_ID) {
    window.gtag("config", GA_TRACKING_ID, {
      page_title: title,
      page_location: url,
    });
  }
};

// Track custom events
export const trackEvent = (
  action: string,
  category: string,
  label: string,
  value?: any
): void => {
  if (typeof window !== "undefined" && GA_TRACKING_ID) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Specific tracking functions for Cohop events

// Track header "Request Exclusive Access" button clicks
export const trackHeaderJoinClick = (): void => {
  trackEvent("click-nav", "navigation", "header_request_access_button");
};

// Track hero WhatsApp button clicks
export const trackHeroWhatsAppClick = (): void => {
  trackEvent("click-hero", "hero", "hero_whatsapp_button");
};

// Track when user starts filling the form (first input interaction)
export const trackFormStart = (): void => {
  trackEvent("form_start", "signup", "signup_form_initiated");
};

// Track successful form submission
export const trackFormSubmit = (formData: SubmitData): void => {
  trackEvent("form_submit", "signup", "signup_form_completed", {
    user_age: formData.age,
    phone_prefix: formData.phonePrefix,
  });
};

// Track success screen WhatsApp community button click
export const trackSuccessWhatsAppClick = (): void => {
  trackEvent(
    "click-join-whatsapp",
    "success_screen",
    "whatsapp_community_button"
  );
};

// Track form validation errors
export const trackFormError = (
  errorType: string,
  errorMessage: string
): void => {
  trackEvent("form_error", "validation", errorType, {
    error_message: errorMessage,
  });
};

// Track section views (for scroll tracking)
export const trackSectionView = (sectionName: string): void => {
  trackEvent("section_view", "engagement", sectionName);
};

// Track navigation menu clicks
export const trackNavClick = (sectionName: string): void => {
  trackEvent("click", "navigation", `nav_${sectionName}`);
};

// Track privacy policy page views
export const trackPrivacyPolicyView = (): void => {
  trackEvent("page_view", "legal", "privacy_policy_view");
};
